export enum FIREBASE {
  STUDY_GUIDE_QUESTIONS = "sgquestions",
  STUDY_GUIDES = "studyguides"
}

export const minUpdateTime = 1667314806;
